import React from 'react';
import PropTypes from 'prop-types';
import LoginWrapper from '../LoginWrapper';

/**
 * Facebook LoginExample provider.
 */
const FacebookLogin = ({
  width, height, title, authorizationUrl, clientId, redirectUri,
  children, scope, provider, responseType, onCode,
}) => (
  <LoginWrapper
    width={width}
    height={height}
    title={title}
    authorizationUrl={authorizationUrl}
    clientId={clientId}
    redirectUri={redirectUri}
    scope={scope}
    provider={provider}
    responseType={responseType}
    onCode={onCode}
  >
    {children}
  </LoginWrapper>
);

/**
 * Define the default props to open the dialog authorization.
 */
FacebookLogin.defaultProps = {
  width: 450,
  height: undefined,
  title: '',
  scope: 'public_profile, email, user_friends',
  provider: 'facebook',
  authorizationUrl: 'https://www.facebook.com/v3.0/dialog/oauth',
  redirectUri: undefined,
  children: undefined,
};

/**
 * Available props to use on component render.
 */
FacebookLogin.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  title: PropTypes.string,
  scope: PropTypes.string,
  authorizationUrl: PropTypes.string,
  redirectUri: PropTypes.string,
  provider: PropTypes.string,
  clientId: PropTypes.string.isRequired,
  responseType: PropTypes.string.isRequired,
  onCode: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default FacebookLogin;
